module.exports = __webpack_public_path__ + "img/548ae89.jpg";